// src/components/AdminPanel/CandidateTable.js
import React, { useState, useEffect } from "react";
import LoadingAnimation from "../LoadingAnimation"; // 🔹 Add this

import { db } from "../../firebase";
import {
  doc,
  deleteDoc,
  updateDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  getDocs,
  where,
} from "firebase/firestore";

const CandidateTable = ({ activeCategory }) => {
  const [candidates, setCandidates] = useState([]);
  const [popup, setPopup] = useState({ visible: false, candidate: null });
  const [confirmDelete, setConfirmDelete] = useState({
    visible: false,
    candidate: null,
  });
  const [viewResume, setViewResume] = useState({
    visible: false,
    candidate: null,
  });
  const [loading, setLoading] = useState(true); 
  const [deleting, setDeleting] = useState(false); 
  const [statusUpdating, setStatusUpdating] = useState(false);

// 👇 Add here (above return)
const getFileType = (url) => {
  if (!url) return "";
  const extension = url.split(".").pop().toLowerCase();
  return extension;
};

  // 🟢 Fetch jobApplications
  useEffect(() => {
    const jobApplicationsQuery = query(
      collection(db, "jobApplications"),
      orderBy("createdAt", "desc")
    );

    const unsubscribeApplications = onSnapshot(
      jobApplicationsQuery,
      (snapshot) => {
        const jobAppData = snapshot.docs.map((doc) => ({
          id: doc.id,
          source: "jobApplications",
          ...doc.data(),
        }));
        setCandidates((prev) => {
          const others = prev.filter((p) => p.source !== "jobApplications");
          return [...others, ...jobAppData];
        });
        setLoading(false);
      }
    );

    return () => {
      unsubscribeApplications();
    };
  }, []);

  // 🟡 Filter candidates by active category
  const currentCandidates = candidates.filter((c) =>
    activeCategory === "upcoming"
      ? c.status === "scheduled" || !c.status
      : c.status === "Selected"
  );

  // 🟠 Open popup for mark done
  const handleMarkDone = (candidate) => {
    setPopup({ visible: true, candidate });
  };

  // 🟠 Open delete confirmation popup
  const handleDeletePopup = (candidate) => {
    setConfirmDelete({ visible: true, candidate });
  };

  const handleDeleteClick = () => {
    setDeleting(true);               // show loader
    setConfirmDelete({ visible: false, candidate: confirmDelete.candidate }); 
    confirmDeleteCandidate();        // continue deletion in background
  };

  // 🔴 Delete candidate after confirmation
  const confirmDeleteCandidate = async () => {
    const { candidate } = confirmDelete;
    if (!candidate) return;
    try {
      const candidateRef = doc(db, candidate.source, candidate.id);
      await deleteDoc(candidateRef);

      // 🔵 Remove date entry from "calendar" if exists
      const calendarRef = collection(db, "calendar");
      const calendarSnap = await getDocs(
        query(calendarRef, where("candidateId", "==", candidate.id))
      );
      calendarSnap.forEach(async (docSnap) => {
        await deleteDoc(doc(db, "calendar", docSnap.id));
      });

      setConfirmDelete({ visible: false, candidate: null });
    } catch (err) {
      console.error("Error deleting candidate:", err);
      alert("Failed to delete candidate.");
    }
  };

  // 🟢 Update status
  const handleStatusUpdate = async (status) => {
    if (!popup.candidate) return;
  
    // 🔹 Immediately hide popup
    setPopup({ visible: false, candidate: null });
  
    // 🔹 Start loading animation
    setStatusUpdating(true);
  
    try {
      const { id, source } = popup.candidate;
      const candidateRef = doc(db, source, id);
      await updateDoc(candidateRef, { status });
  
      // 🔵 If selected → remove from calendar
      if (status === "Selected") {
        const calendarRef = collection(db, "calendar");
        const calendarSnap = await getDocs(
          query(calendarRef, where("candidateId", "==", id))
        );
        calendarSnap.forEach(async (docSnap) => {
          await deleteDoc(doc(db, "calendar", docSnap.id));
        });
      }
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Failed to update candidate status.");
    } finally {
      // 🔹 Stop loading animation
      setStatusUpdating(false);
    }
  };
  

  // 👁️ View Resume Popup
  const handleViewResume = (candidate) => {
    if (!candidate.resumeURL) {
      alert("No resume found for this candidate!");
      return;
    }
    setViewResume({ visible: true, candidate });
  };

  if (loading) return <LoadingAnimation />;  
  return (
    <div className="candidate-table-container" style={{ marginTop: "20px" }}>
      <h2>
        {activeCategory === "upcoming"
          ? "Upcoming Applications"
          : "Completed Interviews"}
      </h2>

      <div style={{ overflowX: "auto" }}>
        <table border="1" cellPadding="10" style={{ width: "100%" }}>
          <thead style={{ backgroundColor: "#f2f2f2" }}>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>CNIC</th>
              <th>Phone</th>
              <th>Job Title</th>
              <th>Interview Date</th>
              <th>Time slot</th>
              <th>Status</th>
              <th>Applied On</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentCandidates.length > 0 ? (
              currentCandidates.map((candidate) => {
                const appliedOn = candidate?.createdAt?.toDate
                  ? candidate.createdAt.toDate().toLocaleString()
                  : "N/A";

                return (
                  <tr key={candidate.id}>
                    <td>{candidate.name || "No Name"}</td>
                    <td>{candidate.email || "No Email"}</td>
                    <td>{candidate.cnic || "No CNIC"}</td>
                    <td>{candidate.phone || "No Phone"}</td>
                    <td>
                      {candidate.position || candidate.jobTitle || "N/A"}
                    </td>
                    <td>{candidate.interviewDate || "N/A"}</td>
                    <td>{candidate.interviewSlot || "—"}</td>
                    <td>
                      <p
                        className="status_chip"
                        style={{
                          backgroundColor: candidate.status === "Selected" 
                                            ? "#21b11d"
                                            : candidate.status === "Rejected" 
                                              ? "#f56565"
                                              : "rgb(241, 172, 12)",
                          color: candidate.status === "Selected" || candidate.status === "Rejected" 
                                  ? "white" 
                                  : "white",
                        }}
                      >
                        {candidate.status || "Pending"}
                      </p>
                    </td>
                    <td>{appliedOn}</td>
                    <td className="icons-flex">
                      {activeCategory === "upcoming" && (
                        <button
                          className="action-button done-button"
                          onClick={() => handleMarkDone(candidate)}
                          title="Mark as done"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="m19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6l1.4-1.4l4.2 4.2zm0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33z"
                            />
                          </svg>
                        </button>
                      )}

                      {/* 👁️ View Resume Button */}
                      <button
                        className="action-button view-button"
                        onClick={() => handleViewResume(candidate)}
                        title="View Resume"
                      >
                        <i className="fas fa-eye"></i>
                      </button>

                      {/* 🗑️ Delete Button */}
                      <button
                        className="action-button delete-button"
                        onClick={() => handleDeletePopup(candidate)}
                        title="Delete candidate"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12l1.41 1.41L13.41 14l2.12 2.12l-1.41 1.41L12 15.41l-2.12 2.12l-1.41-1.41L10.59 14zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No candidates found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

{/* ✅ Status Update Popup */}
{popup.visible && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(4px)",
    }}
  >
    <div
      style={{
        background: "white",
        padding: "32px",
        borderRadius: "16px",
        textAlign: "center",
        width: "340px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        border: "1px solid rgba(255,255,255,0.2)",
      }}
    >
      <div style={{
        width: "48px",
        height: "48px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 16px",
      }}>
        <span style={{ color: "white", fontSize: "18px", fontWeight: "bold" }}>✓</span>
      </div>
      
      <h3 style={{ margin: "0 0 8px 0", color: "#2D3748", fontSize: "18px" }}>
        Update Status
      </h3>
      <p style={{ margin: "0 0 24px 0", color: "#718096", fontSize: "14px" }}>
        <strong style={{ color: "#2D3748" }}>{popup.candidate?.name}</strong>
      </p>

      <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
        <button
          style={{
            background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
            color: "white",
            padding: "12px 20px",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "600",
            flex: 1,
            boxShadow: "0 4px 12px rgba(72, 187, 120, 0.3)",
            transition: "transform 0.2s",
          }}
          onMouseOver={(e) => e.target.style.transform = "translateY(-1px)"}
          onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
          onClick={() => handleStatusUpdate("Selected")}
        >
          Selected
        </button>
        <button
          style={{
            background: "linear-gradient(135deg, #f56565 0%, #e53e3e 100%)",
            color: "white",
            padding: "12px 20px",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "600",
            flex: 1,
            boxShadow: "0 4px 12px rgba(245, 101, 101, 0.3)",
            transition: "transform 0.2s",
          }}
          onMouseOver={(e) => e.target.style.transform = "translateY(-1px)"}
          onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
          onClick={() => handleStatusUpdate("Rejected")}
        >
          Rejected
        </button>
      </div>

      <button
        onClick={() => setPopup({ visible: false, candidate: null })}
        style={{
          width : "content-fit",
          backgroundColor: "#6B6FD5",
          color: "white",
          padding: "10px 20px",
          border: "1px solid #e2e8f0",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#7B6FD5";
          e.target.style.color = "white";
        }}
      >
        Cancel
      </button>
    </div>
  </div>
)}

{/* 🧾 Delete Confirmation Popup */}
{confirmDelete.visible && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(4px)",
    }}
  >
    <div
      style={{
        background: "white",
        padding: "32px",
        borderRadius: "16px",
        textAlign: "center",
        width: "360px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        border: "1px solid rgba(255,255,255,0.2)",
      }}
    >
      <div style={{
        width: "52px",
        height: "52px",
        background: "linear-gradient(135deg, #f56565 0%, #ed8936 100%)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 16px",
      }}>
        <span style={{ color: "white", fontSize: "20px", fontWeight: "bold" }}>!</span>
      </div>
      
      <h3 style={{ margin: "0 0 12px 0", color: "#2D3748", fontSize: "18px" }}>
        Confirm Delete
      </h3>
      <p style={{ margin: "0 0 28px 0", color: "#718096", fontSize: "14px", lineHeight: "1.4" }}>
        Delete <strong style={{ color: "#2D3748" }}>{confirmDelete.candidate?.name}</strong>?
        This action cannot be undone.
      </p>

      <div style={{ display: "flex", gap: "12px" }}>
        <button
          style={{
            backgroundColor: "transparent",
            color: "#718096",
            padding: "12px 24px",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            cursor: "pointer",
            flex: 1,
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#f7fafc";
            e.target.style.color = "#4a5568";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "#718096";
          }}
          onClick={() => setConfirmDelete({ visible: false, candidate: null })}
        >
          Cancel
        </button>
        <button
          style={{
            background: "linear-gradient(135deg, #f56565 0%, #e53e3e 100%)",
            color: "white",
            padding: "12px 24px",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "600",
            flex: 1,
            boxShadow: "0 4px 12px rgba(245, 101, 101, 0.3)",
            transition: "transform 0.2s",
          }}
          onMouseOver={(e) => e.target.style.transform = "translateY(-1px)"}
          onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
          onClick={handleDeleteClick}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}

{/* 👁️ View Resume Modal - IMPROVED MOBILE RESPONSIVE */}
{viewResume.visible && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "10px",
      boxSizing: "border-box",
    }}
    onClick={() => setViewResume({ visible: false, candidate: null })}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: "14px",
        width: "90vw",
        maxWidth: "1200px",
        height: "85vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        border: "1px solid #e5e7eb",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header - Responsive */}
      <div style={{
        padding: "12px 16px",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fafafa",
        flexShrink: 0,
        gap: "12px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "0", flex: "1" }}>
          <div style={{
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "600",
            fontSize: "13px",
            color: "#374151",
            flexShrink: 0,
          }}>
            {viewResume.candidate?.name?.charAt(0)?.toUpperCase()}
          </div>
          <div style={{ minWidth: "0", flex: "1" }}>
            <p style={{ 
              margin: 0, 
              fontWeight: "600", 
              fontSize: "clamp(12px, 4vw, 14px)", 
              color: "#111827",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}>
              {viewResume.candidate?.name}
            </p>
            <p style={{ margin: 0, fontSize: "10px", color: "#9ca3af" }}>Resume</p>
          </div>
        </div>

        <div style={{ 
          display: "flex", 
          gap: "8px", 
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}>
          <a
            href={viewResume.candidate?.resumeURL}
            download
            style={{
              color: "#374151",
              padding: "6px 12px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: "clamp(11px, 3vw, 12px)",
              fontWeight: "500",
              background: "#fff",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              whiteSpace: "nowrap",
            }}
          >
            <span>📥</span> <span style={{ display: "inline" }}>Download</span>
          </a>
          <a
            href={viewResume.candidate?.resumeURL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#374151",
              padding: "6px 12px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: "clamp(11px, 3vw, 12px)",
              fontWeight: "500",
              background: "#fff",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              whiteSpace: "nowrap",
            }}
          >
            <span>🔗</span> <span style={{ display: "inline" }}>Open</span>
          </a>
          <button
            onClick={() => setViewResume({ visible: false, candidate: null })}
            style={{
              background: "#f3f4f6",
              color: "#374151",
              border: "none",
              padding: "6px 12px",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "clamp(11px, 3vw, 12px)",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
          >
            ✕ Close
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, background: "#f9fafb", overflow: "hidden" }}>
        {getFileType(viewResume.candidate?.resumeURL) === "pdf" ? (
          <iframe
            src={viewResume.candidate?.resumeURL}
            title="Resume"
            width="100%"
            height="100%"
            style={{ border: "none", display: "block" }}
          />
        ) : (
          <div style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            color: "#6b7280",
            padding: "20px",
            textAlign: "center",
          }}>
            <div style={{
              width: "48px",
              height: "48px",
              background: "#f3f4f6",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}>
              📄
            </div>
            <p style={{ margin: 0, fontWeight: "500", color: "#374151", fontSize: "clamp(12px, 4vw, 14px)" }}>
              Preview not available
            </p>
            <p style={{ margin: 0, fontSize: "clamp(11px, 3.5vw, 12px)", color: "#9ca3af" }}>
              This file type can't be previewed in the browser.
            </p>
            <a
              href={viewResume.candidate?.resumeURL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginTop: "4px",
                color: "#374151",
                fontSize: "clamp(12px, 3.5vw, 13px)",
                fontWeight: "500",
                padding: "8px 20px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                textDecoration: "none",
                background: "#fff",
              }}
            >
              Open in new tab ↗
            </a>
          </div>
        )}
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default CandidateTable;